import { formatNumber } from "@";
import type { CustomerCampaign } from "../types";

interface CustomerCampaignInfoProps {
  customerCampaign:
    | CustomerCampaign
    | { projectTitle?: string; userName?: string }
    | null;
}

const CustomerCampaignInfo = ({
  customerCampaign,
}: CustomerCampaignInfoProps) => {
  return (
    <>
      {customerCampaign?.userName && (
        <div
          className="mb-4 flex rounded-2xl bg-blue-100 p-4 text-sm text-blue-800 dark:bg-gray-800 dark:text-blue-400"
          role="alert"
        >
          <svg
            className="me-3 mt-[2px] inline h-4 w-4 shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
          </svg>
          <span className="sr-only">Info</span>
          <div>
            <span className="font-medium">
              انت تقوم بإنشاء مشروع من خلال اقتراح حملة من قبل العميل:
            </span>
            <ul className="mt-1.5 list-inside list-disc">
              <li>
                اسم المشروع:
                <strong className="mx-1">
                  {customerCampaign?.projectTitle}
                </strong>
              </li>
              {"requiredAmount" in customerCampaign &&
                customerCampaign?.requiredAmount && (
                  <li>
                    المبلغ المطلوب:
                    <strong className="mx-1">
                      {formatNumber(customerCampaign?.requiredAmount)}
                    </strong>
                  </li>
                )}
              {"classificationName" in customerCampaign &&
                customerCampaign?.classificationName && (
                  <li>
                    تصنيف المشروع:
                    <strong className="mx-1">
                      {customerCampaign?.classificationName}
                    </strong>
                  </li>
                )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerCampaignInfo;
